module.exports = __webpack_public_path__ + "static/media/1017065.a4396731.png";